import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge desconoce los tokens personalizados del proyecto.
// Sin esta config, cuando cn() recibe "text-caption text-tertiary",
// elimina "text-caption" (font-size) porque cree que conflicta con
// "text-tertiary" (color). El resultado: el elemento hereda 16px del html.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        "text-display",
        "text-h1", "text-h2", "text-h3", "text-h4", "text-h5",
        "text-body", "text-body-sm",
        "text-ui-base", "text-ui-sm",
        "text-caption", "text-label", "text-micro",
        "text-code-inline", "text-code-block",
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
